import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddEmbrillProfile = 
  async (data) => {
    try {
      const response = await axiosInstance.post('/organization-bank/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }



export const fetchAsyncUpdateEmbrillProfile = 
    async (data) => {
      try {
        const response = await axiosInstance.post(`/organization-bank/update/${data?.id}`, data?.data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }

export const fetchAsyncGetEmbrillProfile = createAsyncThunk(
    "/fetchAsyncGetEmbrillProfile",
    async () => {
      try {
        let url = `${API_URL}/organization-bank/get`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  
  export const fetchAsyncGetExcelFile = createAsyncThunk(
    "/fetchAsyncGetExcelFile",
    async (data) => {
      try {
        let url = `${API_URL}/organization-bank/get-excel-file`;
       
        const response = await axiosInstance.post(url,data,{ responseType: 'blob' });
        return response;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  export const fetchAsyncGetEmbrillProfileByID = createAsyncThunk(
    "/fetchAsyncGetEmbrillProfileByID",
    async (id) => {
      try {
        let url = `${API_URL}/organization-bank/get-embrill-profile/${id}`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  export const fetchAsyncDeleteEmbrillProfile = 
    async (id) => {
      try {
        let url = `${API_URL}/organization-bank/delete/${id}`;
        const response = await axiosInstance.delete(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }

  export const togglePrimaryBank = async (id, isPrimary) => {
    try {
      let url = `${API_URL}/organization-bank/toggle-primary/${id}`;
      const response = await axiosInstance.put(url, {isPrimary});
      return response.data;
    } catch (error) {
      throw new Error(error?.response?.data?.message);
    }
  }

  export const fetchAsyncUploadExcel = createAsyncThunk(
    "/fetchAsyncUploadExcel",
    async (data) => {
      try {
        let url = `${API_URL}/organization-bank/upload_excel/${data.id}`;
        const response = await axiosInstance.post(url,data.formData);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.msg);
      }
    }
  );

  export const fetchAsyncUpdateExcel = createAsyncThunk(
    "/fetchAsyncUpdateExcel",
    async (data) => {
      try {
        let url = `${API_URL}/organization-bank/update_excel_file/${data.id}`;
        const response = await axiosInstance.post(url,data.formData);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.msg);
      }
    }
  );

  
  export const fetchAsyncDeleteExcel = createAsyncThunk(
    "/fetchAsyncDeleteExcel",
    async (data) => {
      try {
        let url = `${API_URL}/organization-bank/delete_excel/${data.id}`;
        const response = await axiosInstance.post(url,{ key: data.key,index:data?.index,spId:data?.spId });
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.msg);
      }
    }
  );
  export const fetchAsyncSearchEmbrillProfileData = createAsyncThunk(
    "/fetchAsyncSearchEmbrillProfileData",
    async (data) => {
      try {
        let url = `${API_URL}/organization-bank/search`;
        if (data.value) {
          url = url + `?search=${data.value}`;
        }
        if (data.startDate && data.endDate && data.value) {
          url = url + `&startDate=${data.startDate}&endDate=${data.endDate}`;
        }
        if (data.startDate && data.endDate && !data.value) {
          url = url + `?startDate=${data.startDate}&endDate=${data.endDate}`;
        }
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.msg);
      }
    }
  );

  export const fetchAsyncCreateAutomatedBank = createAsyncThunk(
    "/fetchAsyncCreateAutomatedBank",
    async (data) => {
      try {
        const response = await axiosInstance.post('/organization-bank/create-automated', data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  
  
  
  export const fetchAsyncUpdateAutomatedBank = createAsyncThunk(
      "/fetchAsyncUpdateAutomatedBank",
      async (data) => {
        try {
          const response = await axiosInstance.post(`/organization-bank/update-automated/${data?.id}`, data?.data);
          return response.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      }
    );
    export const fetchAsyncGetAutomatedBank = createAsyncThunk(
      "/fetchAsyncGetAutomatedBank",
      async () => {
        try {
          const response = await axiosInstance.get(`/organization-bank/get-automated`);
          return response.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      }
    );
  
    export const fetchAsyncDeleteAccountUser = createAsyncThunk(
      "/fetchAsyncDeleteAccountUser",
      async (data) => {
        try {
          let url = `${API_URL}/organization-bank/delete-user/${data.id}/${data.userId}`;
          const response = await axiosInstance.delete(url);
          return response.data;
        } catch (error) {
          throw new Error(error.response.data.msg);
        }
      }
    );
    export const fetchAsyncGetAccountUser = createAsyncThunk(
      "/fetchAsyncGetAccountUser",
      async (userId) => {
        try {
          let url = `${API_URL}/organization-bank/account-user/${userId}`;
          const response = await axiosInstance.get(url);
          return response.data;
        } catch (error) {
          throw new Error(error.response.data.msg);
        }
      }
    );

    export const fetchAsyncTransactionDetails = createAsyncThunk(
      "/fetchAsyncTransactionDetails",
      async (data) => {
        try {
          const response = await axiosInstance.post(`/organization-bank/transactions`, data);
          return response.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      }
    );
  const AllEmbrillProfileSlice = createSlice({
    name: "embrillProfileData",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetEmbrillProfile.pending]: (state) => {},
      [fetchAsyncGetEmbrillProfile.fulfilled]: (state, { payload }) => {
        return payload;
      },
      [fetchAsyncSearchEmbrillProfileData.pending]: (state) => {},
      [fetchAsyncSearchEmbrillProfileData.fulfilled]: (state, { payload }) => {
        return payload;
      },
    },
  });
  
  export const getAllEmbrillProfile = (state) => state.embrillProfileData;
  
  export default AllEmbrillProfileSlice.reducer;




